import { CoObjectAdvanced } from "../../../components/interfaces/CoObject";
import { DocumentPartMetadata } from "../../../api/models/document-part-metadata";

export function mapMetadataToAdvanced(metadata: DocumentPartMetadata): CoObjectAdvanced {
  return {
    formatMetadata: metadata.formatMetadata ?? undefined,
    formatImage: metadata.formatImage ?? undefined,
    language: metadata.language ?? undefined,
    templateInfo: metadata.templateInfo ?? undefined,
    inDesignLink: metadata.inDesignLink ?? undefined,
    documentId: metadata.documentId ?? undefined,
    logicId: metadata.logicId ?? undefined,
    inheritFormat: false,
  };
}
